import { Engine } from 'excalibur';

// Call once after engine is created (and before you need to render the actor)
export function makeBlurMaterial(engine: Engine, radiusPx = 2) {
    return engine.graphicsContext.createMaterial({
        name: 'blur-9tap',
        fragmentSource: `#version 300 es
precision mediump float;

in vec2 v_uv;
out vec4 fragColor;

uniform sampler2D u_graphic;
uniform vec2 u_graphic_resolution; // provided by Excalibur materials :contentReference[oaicite:3]{index=3}

void main() {
  vec2 texel = 1.0 / u_graphic_resolution;

  // Simple 9-tap blur (box-ish). For “softer”, increase radiusPx or use gaussian weights.
  vec4 c = vec4(0.0);
  c += texture(u_graphic, v_uv + texel * vec2(-${radiusPx}.0, -${radiusPx}.0));
  c += texture(u_graphic, v_uv + texel * vec2( 0.0, -${radiusPx}.0));
  c += texture(u_graphic, v_uv + texel * vec2( ${radiusPx}.0, -${radiusPx}.0));
  c += texture(u_graphic, v_uv + texel * vec2(-${radiusPx}.0,  0.0));
  c += texture(u_graphic, v_uv);
  c += texture(u_graphic, v_uv + texel * vec2( ${radiusPx}.0,  0.0));
  c += texture(u_graphic, v_uv + texel * vec2(-${radiusPx}.0,  ${radiusPx}.0));
  c += texture(u_graphic, v_uv + texel * vec2( 0.0,  ${radiusPx}.0));
  c += texture(u_graphic, v_uv + texel * vec2( ${radiusPx}.0,  ${radiusPx}.0));

  c /= 9.0;

  fragColor = c;
  fragColor.rgb *= fragColor.a; // premultiplied alpha (recommended by Excalibur docs) :contentReference[oaicite:4]{index=4}
}`
    });
}
